import { defineStore } from 'pinia';

export const useReasonStore = defineStore('reason', {
  state: () => ({
    reasons: [
      'Keine Wochenzeitung/Prospekte wurden zugestellt',
      'Die Zustellung erfolgte verspätet',
      'Die Zustellung erfolgte am falschen Ablageort',
      'Es wurden zu wenige Wochenzeitungen/Prospekte zugestellt',
      'Es wurden zu viele Wochenzeitungen/Prospekte zugestellt',
      'Es wurde trotz Werbeverbot zugestellt',
      'Sonstiges (bitte Freitext nutzen)',
    ],
    selectedReason: '',
    selectedReasonIndex: '',
    otherReason: '',
  }),
  getters: {
    getReasons() {
      return this.reasons;
    },
    getSelectedReason() {
      return this.selectedReason;
    },
  },
});
